import { Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import DocumentViewer from "src/reusable-components/DocumentViewer/DocumentViewer";
import { UploadedFilesListProps as Props } from "./interfaces";
import { DocumentViewerContainer } from "./styles";
import UploadedFile from "./UploadedFile";
import { IFile } from "../../reusable-components/DocumentViewer/interfaces";
import DialogTitle from "../DialogTitle/DialogTitle";

const UploadedFilesList = ({ files, saveErrors, attemptedToSave }: Props) => {
  const tRP = "components.add_outgoing_mail.uploaded_files";
  const { t } = useTranslation();

  const [fileToView, setFileToView] = useState<IFile | null>(null);
  return (
    <>
      <Typography>
        {`${t(`${tRP}.title`)}`} ({files.length}) :{" "}
      </Typography>
      <Grid>
        {files.map((_file, idx) => (
          <UploadedFile
            index={idx}
            key={idx}
            file={_file}
            viewThisFile={(_file: IFile) => setFileToView(_file)}
            attemptedToSave={attemptedToSave}
            saveDocumentError={saveErrors.find((failedItem) => failedItem.index === idx)?.saveDocumentError ?? ""}
            saveFileError={saveErrors.find((failedItem) => failedItem.index === idx)?.saveFileError ?? ""}
            saveOutgoingMailError={
              saveErrors.find((failedItem) => failedItem.index === idx)?.saveOutgoingMailError ?? ""
            }
          />
        ))}
      </Grid>

      {!!fileToView && (
        <DocumentViewerContainer open={!!fileToView}>
          <DialogTitle
            title=""
            handleClose={() => {
              setFileToView(null);
            }}
          />
          <Grid style={{ width: "90vw" }}>
            <DocumentViewer
              file={fileToView}
              withFooter
              isGenericDocument
            />
          </Grid>
        </DocumentViewerContainer>
      )}
    </>
  );
};
export default UploadedFilesList;
